"use client"

import * as React from "react"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { setClientCookie, getClientCookie } from "@/lib/cookies/client-cookies"
import { StorefrontRoutesMap } from "@repo/api-shared"

const COOKIE_CONSENT_KEY = "cookie-consent-accepted"

export function CookieConsent() {
    const [isVisible, setIsVisible] = React.useState(false)

    React.useEffect(() => {
        const hasConsent = getClientCookie(COOKIE_CONSENT_KEY)
        if (!hasConsent) {
            setIsVisible(true)
        }
    }, [])

    const acceptCookies = () => {
        setClientCookie(COOKIE_CONSENT_KEY, "true")
        setIsVisible(false)
    }

    if (!isVisible) {
        return null
    }

    return (
        <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-xl">
            <Alert className="border-2 bg-white shadow-lg">
                <AlertDescription className="flex flex-col gap-4">
                    <p>
                        Мы используем файлы cookie для улучшения работы сайта и
                        анализа трафика. Продолжая использовать сайт, вы
                        соглашаетесь с использованием файлов cookie в
                        соответствии с нашей{" "}
                        <a
                            href={StorefrontRoutesMap.PRIVACY}
                            target="_blank"
                            rel="noreferrer"
                            className="text-primary underline hover:text-primary/80"
                        >
                            политикой конфиденциальности
                        </a>
                        .
                    </p>
                    <div className="flex justify-end">
                        <Button onClick={acceptCookies}>
                            Принять и закрыть
                        </Button>
                    </div>
                </AlertDescription>
            </Alert>
        </div>
    )
}
